import { permissionTemplateListPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'
import { PermissionTemplate } from '@/common/model/auth'

import BackButton from '@/components/view/atoms/button/BackButton'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'

import PermissionTemplateForm from '@/components/container/form/modules/site/permission/PermissionTemplateForm'

interface Props {
  template?: PermissionTemplate
  onRefetch?: () => void
}

const PermissionTemplateEditPage = ({ template, onRefetch }: Props) => {
  const siteId = useSiteId()
  return (
    <Main type={MainLayoutType.SMALL}>
      <BackButton link={permissionTemplateListPath(siteId)} />
      <PermissionTemplateForm template={template} onRefetch={onRefetch} />
    </Main>
  )
}

export default PermissionTemplateEditPage
